<div class="px-3">

  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">

      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-id-card font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Add/Edit Creditor</div>
        <div class="text-right mt-2">Manage creditors of remitter</div>
      </div>
      
    </div>
  </div>

<div class="flex justify-content-between">
    <div class="flex flex-row gap-3 align-items-center">
      <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete>

    
         
    </div>

   
    
   
</div>



 <div class="flex justify-content-end">
    <remitter-button   
      (click)="onOpenSideBar()" 
      label='Add New'
      icon='plus'
      severity='info'
    >     
    </remitter-button>
</div>
<div class="mt-4">
     <div 
     *ngIf="!hasTableData"
      style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
              🚫 Failed to get creditor records
      </div>

    <p-table
        *ngIf="hasTableData"
        [value]="creditors" [paginator]="true"
                                           [rows]="10"
                                           [tableStyle]="{ 'min-width': '50rem' }"
                                           [rowsPerPageOptions]="[10, 20, 30]">
        <ng-template pTemplate="header">
            <tr class="text-xs">
                <th>Creditor Id</th>
                <th>Company Name</th>
                <th>website</th>
                <th>Blob Storage Name</th>
                <th>Callback Email Address</th>
                <th>Callback Phone Number</th>
                <th>Payment Portal Url</th>
                <th>Debit Card Gateway</th>
                <th>Bank Account Gateway</th>
                <th>Paypal Gateway</th>
                <th>Enable Payment Plans</th>
                <th>Action</th>               
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-creditor>
            <tr class="text-xs">
                <td>{{ creditor.creditorId }}</td>
                <td>{{ creditor.companyName }}</td>
                <td>{{ creditor.website }}</td>
                <td>{{ creditor.blobStorageName }}</td>  
                <td>{{ creditor.callbackEmailAddress }}</td>    
                <td>{{ creditor.callbackPhoneNumber }}</td>    
                <td>{{ creditor.paymentPortalUrl }}</td>         
                <td>{{ creditor.debitCardGateWay }}</td> 
                <td>{{ creditor.bankAccountGateWay }}</td> 
                <td>{{ creditor.paypalGateWay}}</td>
                <td>{{ creditor.enablePaymentPlans }}</td>                 
                <td>
                    <div class="flex align-items-center">
                        <icon-button
                          pTooltip='Edit'
                          tooltipPosition='left'
                          (click)="onOpenSideBar(creditor)"
                          icon='pencil'
                          styleClass='mr-1'
                        />                        
                      </div>
                </td>       
            </tr>
        </ng-template>
    </p-table>
</div>

</div>

<p-sidebar [(visible)]="isSideBarVisible" styleClass="w-11" position="right">
   <ng-template pTemplate="header">
        <span class="font-bold text-xl">{{ isEditingCreditor? 'Edit' : 'Add New'}} Creditor</span>
        <icon-button
          pTooltip="See Sample JSON Stucture"
          styleClass="ml-2"
          [isRound]="true"
          icon="info-circle font-bold"
          (click)="op.toggle($event)"
          />
            <p-overlayPanel #op>
                <div class="text-sm overflow-y-auto pr-3" style="height: 85vh;">
                  <div *ngFor="let field of creditorSample | keyvalue" class="flex gap-2 mb-1">
                    <span>{{ field.key }}:</span>

                    <!-- If value is NOT object/array -->
                    <span *ngIf="!isObject(field.value)" class="rem-text-default font-medium">
                      {{ field.value !== '' ? field.value : '""' }}
                    </span>

                    <!-- If value is array -->
                    <div *ngIf="isArray(field.value)" class="ml-2">
                      <div *ngFor="let item of  $any(field.value); let i = index" class="mb-1 border-bottom-1 border-300">                        
                          <div *ngFor="let sub of item | keyvalue" class="flex gap-2">
                            <span>{{ sub.key }}:</span>
                            <span class="rem-text-default font-medium">
                              {{ sub.value }}
                            </span>
                          </div>                       
                      </div>                      
                    </div>

                    <!-- If value is object -->
                    <div *ngIf="isObject(field.value) && !isArray(field.value)" class="ml-2">                       
                        <div *ngFor="let sub of $any(field.value) | keyvalue" class="flex gap-2 border-bottom-1 border-300 mb-1">
                          <span>{{ sub.key }}:</span>
                          <span class="rem-text-default font-medium">
                            {{ sub.value }}
                          </span>
                        </div>                      
                    </div>
                  </div>
                </div>
            </p-overlayPanel>
    </ng-template>

<div class="grid">

    <div  class="col-12 md:col-3 mt-4">
        <p-floatLabel>
          <input [disabled]="isEditingCreditor" [(ngModel)]="creditorForm.blobStorageName" (change)="validateForm()" class="w-full" pInputText   id="blobStorageName" />
          <label for="blobStorageName">Blob Storage Name</label>
        </p-floatLabel>

        <div class="p-1 text-red-700 font-bold" *ngIf="validationErrors.blobStorageName">
          <i class="pi pi-exclamation-triangle text-xs font-bold"></i> {{validationErrors.blobStorageName}}
        </div>
    </div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.companyName" class="w-full" pInputText   id="companyName" /><label for="companyName">Company Name</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4">
      <p-floatLabel>
        <input [(ngModel)]="creditorForm.website" (change)="validateForm()"  class="w-full" pInputText   id="website" />
        <label for="website">Website</label>
      </p-floatLabel>

      <div class="p-1 text-red-700 font-bold" *ngIf="validationErrors.website">
        <i class="pi pi-exclamation-triangle text-xs font-bold"></i> {{validationErrors.website}}
      </div>
    </div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel>
      <p-dropdown         
        [filter]="true"
        [options]="industryOptions" 
        optionLabel="label" 
        optionValue="value" 
        [(ngModel)]="creditorForm.industryVertical" 
        class="w-full" 
        styleClass="w-full"
        id="industryVertical" />
      <label for="industryVertical">Industry Vertical</label>
    </p-floatLabel></div>
   
  

    <div  class="col-12 md:col-3 mt-4">
      <p-floatLabel>
         <p-dropdown 
          [options]="TIME_ZONES" 
          [filter]="true"
          class="w-full" 
          styleClass="w-full"
          [(ngModel)]="creditorForm.timeZone" 
          id="timeZone" />
        <label for="timeZone">Timezone</label></p-floatLabel>
    </div>
    <div  class="col-12 md:col-3 mt-4">
      <p-floatLabel>
        <p-dropdown           
          [filter]="true"
          [options]="DATE_FORMATS"          
          [(ngModel)]="creditorForm.dateFormat" 
          class="w-full" 
          styleClass="w-full"
          id="dateFormat" />
          <label for="dateFormat">Date Format</label>
        </p-floatLabel>
      </div>
    
  
    <div  class="col-12 md:col-3 mt-4">
      <p-floatLabel>
        <input 
            [(ngModel)]="creditorForm.alertsEmailAddress" 
            class="w-full" 
            pInputText   
            id="alertsEmailAddress"
            (change)="validateForm()" 
            />
        <label for="alertsEmailAddress">Alerts Email Address</label>
      </p-floatLabel>
      <div class="p-1 text-red-700 font-bold" *ngIf="validationErrors.alertsEmailAddress">
        <i class="pi pi-exclamation-triangle text-xs font-bold"></i> {{validationErrors.alertsEmailAddress}}
      </div>
    </div>
    
    <div  class="col-12 md:col-3 mt-4">
      <p-floatLabel>
        <input 
              [(ngModel)]="creditorForm.callbackEmailAddress" 
              class="w-full" 
              pInputText   
              id="callbackEmailAddress" 
              (change)="validateForm()"
              />
        <label for="callbackEmailAddress">Callback Email Address</label>
      </p-floatLabel>
      <div class="p-1 text-red-700 font-bold" *ngIf="validationErrors.callbackEmailAddress">
        <i class="pi pi-exclamation-triangle text-xs font-bold"></i> {{validationErrors.callbackEmailAddress}}
      </div>
    </div>

    <div  class="col-12 md:col-3 mt-4">
        <p-floatLabel>
            <input 
                [(ngModel)]="creditorForm.callbackPhoneNumber" 
                class="w-full" 
                pInputText   
                id="callbackPhoneNumber" 
                (change)="validateForm()"
                />
            <label for="callbackPhoneNumber">Callback Phone Number</label>
        </p-floatLabel>
        <div class="p-1 text-red-700 font-bold" *ngIf="validationErrors.callbackPhoneNumber">
          <i class="pi pi-exclamation-triangle text-xs font-bold"></i> {{validationErrors.callbackPhoneNumber}}
        </div>
    </div>

    <div  class="col-12 md:col-3 mt-4">
      <p-floatLabel>
        <p-dropdown
          [filter]="true"
          [options]="PHONE_NUMBER_PREFIXES"
          [(ngModel)]="creditorForm.countryPhoneNumberPrefix"       
          styleClass="w-full"
          class="w-full"
          optionLabel="label"        
          optionValue="value"                 
          id="countryPhoneNumberPrefix" 
          >
            <ng-template pTemplate="item" let-t>
                <div class="flex justify-content-between">
                  <span>{{ t.label }}</span>
                  <span>{{ t.value }}</span>
                </div>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-t>
                  <div *ngIf="t" class="flex justify-content-between">
                    <span>{{ t.value }}</span>
                    <span>{{ t.label }}</span>
                  </div>
                  <span *ngIf="!t" class="text-color-secondary">Select payment type</span>
            </ng-template>
        </p-dropdown>
        <label for="countryPhoneNumberPrefix">Country Phone Number Prefix</label></p-floatLabel>
      </div>


    <div  class="col-12 md:col-3 mt-4">
        <p-floatLabel>
            <input 
              [(ngModel)]="creditorForm.paymentPortalUrl" 
              class="w-full" 
              pInputText   
              id="paymentPortalUrl" 
              (change)="validateForm()"
              />
            <label for="paymentPortalUrl">Payment Portal URL</label>
          </p-floatLabel>
          <div class="p-1 text-red-700 font-bold" *ngIf="validationErrors.paymentPortalUrl">
           <i class="pi pi-exclamation-triangle text-xs font-bold"></i> {{validationErrors.paymentPortalUrl}}
          </div>
    </div>

 
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><p-inputNumber styleClass="w-full" [(ngModel)]="creditorForm.daysAfterDueTillDefault"  id="daysAfterDueTillDefault" /><label for="daysAfterDueTillDefault">Days After Due Till Default</label></p-floatLabel></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><p-inputNumber styleClass="w-full" [(ngModel)]="creditorForm.repaymentWindowInDays"  id="repaymentWindowInDays" /><label for="repaymentWindowInDays">Repayment Window In Days</label></p-floatLabel></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><p-inputNumber styleClass="w-full" [(ngModel)]="creditorForm.minimumAllowableInvoiceAmountForPartial"  id="minimumAllowableInvoiceAmountForPartial" /><label for="minimumAllowableInvoiceAmountForPartial">Min Allowable Invoice Amount for Partial</label></p-floatLabel></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><p-inputNumber styleClass="w-full" [(ngModel)]="creditorForm.minimumAllowablePartialAmount"  id="minimumAllowablePartialAmount" /><label for="minimumAllowablePartialAmount">Minimum Allowable Partial Amount</label></p-floatLabel></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><p-inputNumber styleClass="w-full" [(ngModel)]="creditorForm.minimumAllowableInvoiceAmountForPaymentPlan"  id="minimumAllowableInvoiceAmountForPaymentPlan" /><label for="minimumAllowableInvoiceAmountForPaymentPlan">Min Allowable Invoice Amount For Payment Plan</label></p-floatLabel></div>
    

    <div class="col-12 md:col-3 mt-4"><p-floatLabel><textarea pInputTextarea [(ngModel)]="creditorForm.outstandingText" rows="1" class="w-full" id="outstandingText"></textarea><label for="outstandingText">Website Outstanding Text</label></p-floatLabel></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><textarea pInputTextarea [(ngModel)]="creditorForm.termsAndConditions" rows="1" class="w-full" id="termsAndConditions"></textarea><label for="termsAndConditions">Terms & Conditions</label></p-floatLabel></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><textarea pInputTextarea [(ngModel)]="creditorForm.legalActionText" rows="1" class="w-full" id="legalActionText"></textarea><label for="legalActionText">Legal Action Text</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.desktopLogo" class="w-full"  pInputText id="desktopLogo" /><label for="desktopLogo">Desktop Logo</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.mobileLogo" class="w-full" pInputText id="mobileLogo" /><label for="mobileLogo">Mobile Logo</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.emailLogo" class="w-full" pInputText id="emailLogo" /><label for="emailLogo">Email Logo</label></p-floatLabel></div>
   

    <div class="col-12 md:col-3 mt-4">
      <p-floatLabel>
        <p-dropdown
          [filter]="true"
          [options]="paymentTypeOptions"
          [(ngModel)]="creditorForm.debitCardGateWay"            
          styleClass="w-full"          
          optionLabel="label"        
          optionValue="value"                 
          id="debitCardGateWay" 
          >
            <ng-template pTemplate="item" let-t>
                <div class="flex justify-content-between">
                  <span>{{ t.label }}</span>
                  <span>{{ t.value }}</span>
                </div>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-t>
                  <div *ngIf="t" class="flex justify-content-between">
                    <span>{{ t.value }}</span>
                    <span>{{ t.label }}</span>
                  </div>
                  <span *ngIf="!t" class="text-color-secondary">Select payment type</span>
            </ng-template>
        </p-dropdown>
        <label>Debit Card Gateway</label>
      </p-floatLabel>
    </div>
    <div class="col-12 md:col-3 mt-4">
      <p-floatLabel>
        <p-dropdown 
          [filter]="true"
          styleClass="w-full"          
          [options]="paymentTypeOptions"          
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="creditorForm.creditCardGateWay"  
          id="creditCardGateWay">
           <ng-template pTemplate="item" let-t>
                <div class="flex justify-content-between">
                  <span>{{ t.label }}</span>
                  <span>{{ t.value }}</span>
                </div>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-t>
                  <div *ngIf="t" class="flex justify-content-between">
                    <span>{{ t.value }}</span>
                    <span>{{ t.label }}</span>
                  </div>
                  <span *ngIf="!t" class="text-color-secondary">Select payment type</span>
            </ng-template>
          </p-dropdown>
          <label>Credit Card Gateway</label>
      </p-floatLabel>
    </div>
    
    <div *ngIf="isShowField['bankAccountGateWay']" class="col-12 md:col-3 mt-4 flex align-items-center gap-1">
      <p-floatLabel class="flex-1">
         <p-dropdown 
          [filter]="true"
          styleClass="w-full"          
          [options]="paymentTypeOptions"          
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="creditorForm.bankAccountGateWay"  
          id="bankAccountGateWay">
           <ng-template pTemplate="item" let-t>
                <div class="flex justify-content-between">
                  <span>{{ t.label }}</span>
                  <span>{{ t.value }}</span>
                </div>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-t>
                  <div *ngIf="t" class="flex justify-content-between">
                    <span>{{ t.value }}</span>
                    <span>{{ t.label }}</span>
                  </div>
                  <span *ngIf="!t" class="text-color-secondary">Select payment type</span>
            </ng-template>
        </p-dropdown>
        <label>Bank Gateway</label>
      </p-floatLabel>
      <icon-button
          [isRound]="true"
          icon="times"
          (click)="onRemoveField('bankAccountGateWay')"
          />
    </div>
    <div *ngIf="isShowField['paypalGateWay']" class="col-12 md:col-3 mt-4 flex align-items-center gap-1">
      <p-floatLabel class="flex-1">
        <p-dropdown 
          [filter]="true"
          styleClass="w-full"          
          [options]="paymentTypeOptions"          
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="creditorForm.paypalGateWay"  
          id="paypalGateWay" 
          >
           <ng-template pTemplate="item" let-t>
                <div class="flex justify-content-between">
                  <span>{{ t.label }}</span>
                  <span>{{ t.value }}</span>
                </div>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-t>
                  <div *ngIf="t" class="flex justify-content-between">
                    <span>{{ t.value }}</span>
                    <span>{{ t.label }}</span>
                  </div>
                  <span *ngIf="!t" class="text-color-secondary">Select payment type</span>
            </ng-template>
        </p-dropdown>
        <label>Paypal Gateway</label>
      </p-floatLabel>

      <icon-button
        [isRound]="true"
        icon="times"
        (click)="onRemoveField('paypalGateWay')"
        />
    </div>
    


    <div class="col-12"></div>  

    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.enableInvoiceChallenge"  binary="true" inputId="enableInvoiceChallenge"></p-checkbox><label class="ml-2" for="enableInvoiceChallenge">Enable Invoice Challenge</label></div>
    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.baselineDebtAgeToUploadDate"  binary="true" inputId="baselineDebtAgeToUploadDate"></p-checkbox><label class="ml-2">Baseline Debt Age to Upload Date</label></div>
  
     <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.enablePartialPayments"  binary="true" inputId="enablePartialPayments"></p-checkbox><label class="ml-2">Enable Partial Payments</label></div>
   
    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.enablePaymentPlans"  binary="true" inputId="enablePaymentPlans"></p-checkbox><label class="ml-2">Enable Plans</label></div>
    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.bypassPolicySystem"  binary="true" inputId="bypassPolicySystem"></p-checkbox><label class="ml-2">Bypass Policy System</label></div>
    
    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.sendPaymentPlanEmailReminder"  binary="true" inputId="sendPaymentPlanEmailReminder"></p-checkbox><label class="ml-2">Send Payment Plan Email Reminder</label></div>
    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.sendPaymentPlanSmsReminder"  binary="true" inputId="sendPaymentPlanSmsReminder"></p-checkbox><label class="ml-2">Send Payment Plan SMS Reminder</label></div>

    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.toggleCompletePaymentPlanOnInitialEndDate"  binary="true" inputId="toggleCompletePaymentPlanOnInitialEndDate"></p-checkbox><label class="ml-2">Toggle Complete Payment Plan On Initial End Date</label></div>
    
    
    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.enableSinglePayment"  binary="true" inputId="enableSinglePayment"></p-checkbox><label class="ml-2">Enable Single Payment</label></div>
    <div class="col-12 md:col-2 flex align-items-start"><p-checkbox [(ngModel)]="creditorForm.isActive"  binary="true" inputId="isActive"></p-checkbox><label class="ml-2">Is Active</label></div>

    

    <div class="col-12 mt-4 py-0">
        <h4 class="font-medium rem-text">Additional Fields</h4>
    </div>
    <div class="col-12 flex gap-2 pt-0">

      <remitter-chip *ngIf="!isShowField['bankAccountGateWay']" label="Bank Gateway" icon="plus" (click)="onAddField('bankAccountGateWay')" />
      <remitter-chip *ngIf="!isShowField['paypalGateWay']" label="Paypal Gateway" icon="plus" (click)="onAddField('paypalGateWay')" />
    </div>  
    

    <!-- ------------------Not found in SQL Creditor Table----------------------
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.Country" class="w-full" pInputText   id="Country" /><label for="Country">Country</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.State" class="w-full" pInputText   id="State" /><label for="State">State</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.City" class="w-full" pInputText   id="City" /><label for="City">City</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.PostalCode" class="w-full" pInputText   id="PostalCode" /><label for="PostalCode">Postal Code</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.StreetNumber" class="w-full" pInputText   id="StreetNumber" /><label for="StreetNumber">Street Number</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input [(ngModel)]="creditorForm.StreetName" class="w-full" pInputText   id="StreetName" /><label for="StreetName">Street Name</label></p-floatLabel></div>

    <div class="col-12 md:col-2"><p-checkbox   binary="true" inputId="ForceDefaultLanguage"></p-checkbox><label class="ml-2">Force Language</label></div>
    <div class="col-12 md:col-2"><p-checkbox  binary="true" inputId="FailedPaymentRetryEnabled"></p-checkbox><label class="ml-2">Retry Enabled</label></div>
    <div class="col-12 md:col-2"><p-checkbox   binary="true" inputId="FailedPaymentRetryEndPaymentPlan"></p-checkbox><label class="ml-2">End Plan on Fail</label></div>
    <div class="col-12 md:col-3 mt-4 flex align-items-center"><p-checkbox  binary="true" inputId="SharingEnabled"></p-checkbox><label class="ml-2">Sharing Enabled</label></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><input class="w-full" pInputText   id="SharingMessage" /><label>Sharing Message</label></p-floatLabel></div>
   
   
    
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input  class="w-full" pInputText   id="CreditorPortalUrl" /><label for="CreditorPortalUrl">Creditor Portal URL</label></p-floatLabel></div>
    <div  class="col-12 md:col-3 mt-4"><p-floatLabel><input  class="w-full" pInputText   id="SupportContactNumber" /><label for="SupportContactNumber">Support Contact Number</label></p-floatLabel></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><p-inputNumber   id="FailedPaymentRetryMaximumRetry" /><label>Max Retry</label></p-floatLabel></div>
    <div class="col-12 md:col-3 mt-4"><p-floatLabel><p-inputNumber   id="FailedPaymentRetryIntervalInHours" /><label>Retry Interval (hrs)</label></p-floatLabel></div>
    

    <div class="col-12 mt-4 grid">
      <div class="col-12 md:col-6 flex align-items-center justify-content-between">
          <h4 class="mt-3 font-medium">Payment Plans</h4>

          <remitter-button
            icon="plus"
            label="Add Row"
            severity="secondary"
            (click)="addMorePaymentPlan()"
          />
      </div>

    </div>

    <div  *ngFor="let paymentPlan of paymentPlans; let i = index;"  class="col-12 grid pt-4">
      <div class="flex pt-3">
        <icon-button         
               pTooltip='Remove Payment Plan'
               tooltipPosition='left'
               (click)="onDeletePaymentPlan(i)"
               [icon]="'trash'"
          />  
      </div>
      <div class="col-12 md:col-3">
         
        <p-floatLabel><input [(ngModel)]="paymentPlan.Frequency" [(ngModel)]="creditorForm.blobStorageName" class="w-full" pInputText   id="Frequency1" /><label>Frequency</label></p-floatLabel>
      </div>
      <div class="col-12 md:col-3"><p-floatLabel><input [(ngModel)]="paymentPlan.MinAmount" [(ngModel)]="creditorForm.blobStorageName" class="w-full" pInputText   id="MinAmount1" /><label>Min Amount</label></p-floatLabel></div>
      <div class="col-12 md:col-3">
        <p-checkbox [(ngModel)]="creditorForm.paypalGateWay"  binary="true" [(ngModel)]="paymentPlan.Enable" inputId="Enable1"></p-checkbox><label class="ml-2">Enable</label>
        
      </div>
      
    </div>

    <div class="col-12 mt-4 grid">
      <div class="col-12 md:col-6 flex align-items-center justify-content-between">
          <h4  class="mt-3 font-medium">Contact Points</h4>

          <remitter-button
            icon="plus"
            label="Add Row"
            severity="secondary"
          />
      </div>
    </div>

    <div *ngFor="let contactPoint of contactPoints; let i = index" class="col-12 grid">
      <div class="flex pt-3">
        <icon-button         
               pTooltip='Remove Payment Plan'
               tooltipPosition='left'
               (click)="onDeleteContactPoint(i)"
               [icon]="'trash'"
          />  
      </div>
      <div class="col-12 md:col-3"><p-floatLabel><input 
        [(ngModel)]="contactPoint.ButtonText"
        [(ngModel)]="creditorForm.blobStorageName" class="w-full" pInputText   id="ButtonText" /><label>Button Text</label></p-floatLabel></div>
      <div class="col-12 md:col-3"><p-floatLabel><input 
        [(ngModel)]="contactPoint.ContactNumber"
        [(ngModel)]="creditorForm.blobStorageName" class="w-full" pInputText   id="ContactNumber" /><label>Contact Number</label></p-floatLabel></div>
    </div> 
    ------------------Not found in SQL Creditor Table----------------------
    -->
    

</div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
          <remitter-button
            (click)="onSave()" 
            label='Save'
            icon='send'
          >     
          </remitter-button>
        </div>
    </ng-template>
    
</p-sidebar>
